import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

export const iMessage: DynamicLayout = {
  json: {
    menu: {
      menuType: 'iMessage',
      menuHeader: '',
      menuParams: {
        subtitle: '',
        imageReference: '',
        imageTitle: '',
        imageSubtitle: '',
        appIconReference: '',
        appId: '',
        appName: '',
        bid: '',
        URL: '',
        secondarySubtitle: '',
        tertiarySubtitle: '',
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.imageReference',
    'menu.menuHeader',
    'menu.menuParams.subtitle',
    'menu.menuParams.imageTitle',
    'menu.menuParams.imageSubtitle',
    'menu.menuParams.appIconReference',
    'menu.menuParams.appId',
    'menu.menuParams.appName',
    'menu.menuParams.bid',
    'menu.menuParams.URL',
    'menu.menuParams.secondarySubtitle',
    'menu.menuParams.tertiarySubtitle',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.imageReference',
        'menu.menuHeader',
        'menu.menuParams.subtitle',
        'menu.menuParams.imageTitle',
        'menu.menuParams.imageSubtitle',
        'menu.menuParams.appIconReference',
        'menu.menuParams.appId',
        'menu.menuParams.appName',
        'menu.menuParams.bid',
        'menu.menuParams.URL',
        'menu.menuParams.secondarySubtitle',
        'menu.menuParams.tertiarySubtitle',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    menuHeader: {
      type: 'text',
      label: 'Title',
      validators: {
        required: true,
      },
    },
    subtitle: {
      type: 'text',
      label: 'Subtitle',
    },
    imageReference: {
      type: 'image',
      label: '',
      validators: {
        required: false,
      },
    },
    imageTitle: {
      type: 'text',
      label: 'ImageTitle',
    },
    imageSubtitle: {
      type: 'text',
      label: 'ImageSubtitle',
    },
    appIconReference: {
      type: 'text',
      label: 'AppIcon Reference',
      validators: {
        required: true,
      },
    },
    appId: {
      type: 'text',
      label: 'AppId',
      validators: {
        required: true,
      },
    },
    appName: {
      type: 'text',
      label: 'AppName',
      validators: {
        required: true,
      },
    },
    bid: {
      type: 'text',
      label: 'Bid',
      validators: {
        required: true,
      },
    },
    URL: {
      type: 'text',
      label: 'URL',
      validators: {
        required: true,
      },
    },
    secondarySubtitle: {
      type: 'text',
      label: 'SecondarySubtitle',
    },
    tertiarySubtitle: {
      type: 'text',
      label: 'TertiarySubtitle',
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
};
